// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4aff86e1","453":"6a59f831","455":"de6db0c3"}[chunkId] + ".chunk.js";
};